var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('Doughnut',{staticClass:"doughnut-dashboard",attrs:{"chart-data":_vm.chartData,"chart-options":_vm.chartOptions}}):_c('img',{staticClass:"doughnut-dashboard__img",attrs:{"src":require("@/assets/img/diagram/empty-diagram.svg"),"alt":"empty-diagram"}})
}
var staticRenderFns = []

export { render, staticRenderFns }